import {Component, OnInit} from '@angular/core';
import {TypeUtils} from "../../../../../../../shared/utils/type-utils";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {CloudflareService} from "../../../../services/cloudflare.service";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../../../../../user/user-subscription";
import cdnSteps from "./cdn-steps.json"

interface ISteps {
  id: string,
  desc: string,
  withLabel?: boolean,
  withTxt?: boolean
}
@Component({
    selector: 'db-cdn-notice-section',
    templateUrl: './cdn-notice-section.component.html',
    styleUrls: ['./cdn-notice-section.component.scss'],
    standalone: false
})
export class CdnNoticeSectionComponent implements OnInit {
  public websiteId: number;
  public userSubscription: UserSubscription;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public cdnSteps: ISteps[] = cdnSteps;
  public records: any[] = [];
  public isCopiedHostNames: any = [];
  public isCopiedCodes: any = [];
  public dcvRecordsForCopy: any[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _cloudflareService: CloudflareService,
    private _dbModalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this._getUserSubscription();
    this._getCFData();
  }

  private _getUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
      });
  }

  private _getCFData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
        filter((data) => !TypeUtils.isEmpty(data)),
      )
      .subscribe(data => {
        this._resetData();
        data && data.dcvVerificationRecords && (this.dcvRecordsForCopy = [...this.dcvRecordsForCopy, ...data.dcvVerificationRecords]);
        this.records = this.dcvRecordsForCopy;
      });
  }

  public copiedHostName(index: number) {
    this.isCopiedHostNames[index] = true;
  }

  public copiedNameServer(index: number) {
    this.isCopiedCodes[index] = true;
  }

  public sendEvent(action: string): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _resetData(): void {
    this.dcvRecordsForCopy = [];
    this.records = [];
    this.isCopiedHostNames = [];
    this.isCopiedCodes = [];
  }
}
